var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_779_10896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2236 16.624C19.9628 13.8666 19.8894 9.46742 17.0597 6.79819C14.23 4.12896 9.71558 4.20047 6.97642 6.95791C4.23725 9.71534 4.31063 14.1145 7.14032 16.7837C9.97 19.453 14.4844 19.3815 17.2236 16.624Z",
    stroke: "#0E2483",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1085 9.02076L12.2073 14.9445",
    stroke: "#0E2483",
    strokeWidth: 1.43203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11841 12.0308L15.1973 11.9345",
    stroke: "#0E2483",
    strokeWidth: 1.43203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_779_10896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.89,
    height: 16.9042,
    fill: "white",
    transform: "matrix(0.704752 -0.709453 0.72743 0.686182 0 11.9827)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2911f0f1bb54043305e47cefeeca9d22.svg";
export { ForwardRef as ReactComponent };